import c0 from './annotations_controller';
import c1 from './autocomplete_controller';
import c2 from './browser_extension_controller';
import c3 from './clipboard_controller';
import c4 from './dialog_controller';
import c5 from './dropzone_controller';
import c6 from './fullscreen_controller';
import c7 from './history_controller';
import c8 from './inplace_input_controller';
import c9 from './login_form_controller';
import c10 from './menu_controller';
import c11 from './modal_images_controller';
import c12 from './modal_videos_controller';
import c13 from './panel_controller';
import c14 from './pass_reveal_controller';
import c15 from './remote_controller';
import c16 from './remover_controller';
import c17 from './request_controller';
import c18 from './scrollto_controller';
import c19 from './scroll_progress_controller';
import c20 from './scroll_tracker_controller';
import c21 from './styler_controller';
import c22 from './tabs_controller';
import c23 from './theme_controller';
import c24 from './timetoken_controller';
import c25 from './turbo_form_controller';
import c26 from './turbo_refresh_controller';
import c27 from './turbo_reload_controller';
import c28 from './video_controller';
export const definitions = [
	{identifier: 'annotations', controllerConstructor: c0},
	{identifier: 'autocomplete', controllerConstructor: c1},
	{identifier: 'browser-extension', controllerConstructor: c2},
	{identifier: 'clipboard', controllerConstructor: c3},
	{identifier: 'dialog', controllerConstructor: c4},
	{identifier: 'dropzone', controllerConstructor: c5},
	{identifier: 'fullscreen', controllerConstructor: c6},
	{identifier: 'history', controllerConstructor: c7},
	{identifier: 'inplace-input', controllerConstructor: c8},
	{identifier: 'login-form', controllerConstructor: c9},
	{identifier: 'menu', controllerConstructor: c10},
	{identifier: 'modal-images', controllerConstructor: c11},
	{identifier: 'modal-videos', controllerConstructor: c12},
	{identifier: 'panel', controllerConstructor: c13},
	{identifier: 'pass-reveal', controllerConstructor: c14},
	{identifier: 'remote', controllerConstructor: c15},
	{identifier: 'remover', controllerConstructor: c16},
	{identifier: 'request', controllerConstructor: c17},
	{identifier: 'scrollto', controllerConstructor: c18},
	{identifier: 'scroll-progress', controllerConstructor: c19},
	{identifier: 'scroll-tracker', controllerConstructor: c20},
	{identifier: 'styler', controllerConstructor: c21},
	{identifier: 'tabs', controllerConstructor: c22},
	{identifier: 'theme', controllerConstructor: c23},
	{identifier: 'timetoken', controllerConstructor: c24},
	{identifier: 'turbo-form', controllerConstructor: c25},
	{identifier: 'turbo-refresh', controllerConstructor: c26},
	{identifier: 'turbo-reload', controllerConstructor: c27},
	{identifier: 'video', controllerConstructor: c28},
];
